import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query";
import api, { RestApiOptions } from "@/api";
import { ApiCatalog } from "@/api/catalogs/ApiCatalog";

const oneMinuteInMilliseconds = 60000;

interface UseOutlineQueryProps<T> {
  contentId: string;
  queryParams?: Record<string, string>;
  options?: UseQueryOptions<T, Error, T>;
  apiOptions?: RestApiOptions;
}

const useSingleContent = <T = any>({
  contentId,
  queryParams = { viewmodel_type: "outline" },
  options,
  apiOptions = {
    timeout: oneMinuteInMilliseconds,
  },
}: UseOutlineQueryProps<T>): UseQueryResult<T, Error> => {
  const queryParamsString = new URLSearchParams(queryParams).toString();

  return useQuery<T, Error, T>({
    queryKey: [ApiCatalog.singleContent.key, contentId, queryParamsString],
    queryFn: () =>
      api(apiOptions).get(ApiCatalog.singleContent.endpoint, {
        queryParams,
        urlReplacers: [{ id: contentId }],
      }) as Promise<T>,
    ...options,
  });
};

export default useSingleContent;
